import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";


@Component({
    selector: 'bm-dunning-type-trigger-object',
    templateUrl: 'bm-dunning-type-trigger-object.component.html',
    standalone: false
})
export class BmDunningTypeTriggerObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {


    /**
     * On Object Change.
     */
    onObjectChanged() {

    }

    ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
